import { NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { sidebarItems } from "@/components/layout/SidebarItems";
import { useAuth } from "@/hooks/useAuth";

const Sidebar = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const handleLogout = () => {
    const confirm = window.confirm("Tem certeza que deseja sair?");
    if (confirm) {
      logout();
      navigate("/login");
    }
  };

  return (
    <aside className="hidden min-h-screen w-64 shrink-0 flex-col border-r border-border bg-card/50 lg:flex">
      <div className="flex items-center gap-2 px-6 py-6 text-lg font-semibold">
        <span className="text-2xl">💰</span>
        <span className="text-base font-semibold">FinanceDashboard</span>
      </div>
      <nav className="flex-1 px-4">
        <ul className="space-y-1">
          {sidebarItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground",
                    isActive &&
                      "bg-primary text-primary-foreground hover:bg-primary",
                  )
                }
              >
                <item.icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="mt-auto p-4">
        <Button
          variant="ghost"
          className="w-full justify-start gap-2"
          onClick={handleLogout}
        >
          <LogOut className="h-4 w-4" />
          Sair
        </Button>
      </div>
    </aside>
  );
};

export default Sidebar;
